import { render, staticRenderFns } from "./stock_record_list.vue?vue&type=template&id=1d9cf473&scoped=true"
import script from "./stock_record_list.vue?vue&type=script&lang=js"
export * from "./stock_record_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9cf473",
  null
  
)

export default component.exports